import { render, staticRenderFns } from "./coupons-list.vue?vue&type=template&id=7ebdfda0&"
import script from "./coupons-list.vue?vue&type=script&lang=js&"
export * from "./coupons-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ebdfda0')) {
      api.createRecord('7ebdfda0', component.options)
    } else {
      api.reload('7ebdfda0', component.options)
    }
    module.hot.accept("./coupons-list.vue?vue&type=template&id=7ebdfda0&", function () {
      api.rerender('7ebdfda0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/account/coupon/coupons-list.vue"
export default component.exports